import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PortalApp from './PortalApp';
import BackofficeApp from './BackOfficeApp';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/backoffice" element={<BackofficeApp />} />
        <Route path="/:tenantName?" element={<PortalApp />} />
      </Routes>
    </Router>
  </React.StrictMode>
);